define('router/router-tasks/marketing-channel-task',['require','api-access','api-access','cookie-handler'],function (require) {
    var userApi = require('api-access').user;
    var meetingsApi = require('api-access').meetings;
    var cookieHandler = require('cookie-handler');

    return function (marketingChannel) {
        // check if we need to redirect based on marketing cookie
        // or on user state. Once commerce APIs support promotion,
        // stop this marketing integration and use commerce apis
        // to drive the routing
        var channelRouteMapping = {
            'G2MR1-011615-002': 'inviteUsers',
            'G2M-PRICE-022515-002': 'setup',
            'g2m-judo': 'setup'
        };

        if (marketingChannel) {
            cookieHandler.clear('marketingChannel');
            cookieHandler.setTime(60 * 1000, marketingChannel, true);
            userApi.me().then(function (me) {
                if (me.grantedAuthorities.indexOf('ROLE_G2M_ORGANIZER') > -1) {
                    meetingsApi.updateAccountSettings(me.accountKey, {marketingChannel: marketingChannel});
                }
            });

            var route = channelRouteMapping[marketingChannel];
            if (route) {
                return route;
            }
        }

        return '';
    };
});

